"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRoomData = exports.validateSupportDeliveryDate = exports.validateCommissionContents = exports.validateRoomCategory = exports.validateRoomTitle = exports.validateRoomMainPhoto = void 0;
const i18next_1 = __importDefault(require("i18next"));
const string_utils_1 = require("@/common/string_utils");
const validateRoomMainPhoto = (mainPhoto) => {
    let validation;
    if (!mainPhoto) {
        validation = `${i18next_1.default.t('대표 이미지를 등록해주세요')}`;
    }
    return validation;
};
exports.validateRoomMainPhoto = validateRoomMainPhoto;
const validateRoomTitle = ({ roomTitle, isCommission, }) => {
    let validation;
    if (!roomTitle) {
        validation = `${i18next_1.default.t(isCommission ? '커미션 타입 이름을 입력해 주세요' : '제목을 입력해 주세요')}`;
    }
    return validation;
};
exports.validateRoomTitle = validateRoomTitle;
const validateRoomCategory = (category) => {
    let validation;
    if (!(category === null || category === void 0 ? void 0 : category.id)) {
        validation = `${i18next_1.default.t('무엇을 판매하시나요? 선택해주세요')}`;
    }
    return validation;
};
exports.validateRoomCategory = validateRoomCategory;
const validateCommissionContents = (commissionContents) => {
    let validation;
    if (!commissionContents) {
        validation = `${i18next_1.default.t('커미션 설명을 입력해주세요')}`;
    }
    return validation;
};
exports.validateCommissionContents = validateCommissionContents;
const validateSupportDeliveryDate = ({ supportDeliveryDate, regularSales, }) => {
    let validation;
    if (!regularSales && !supportDeliveryDate) {
        validation = `${i18next_1.default.t('배송 예정일을 선택해주세요')}`;
    }
    return validation;
};
exports.validateSupportDeliveryDate = validateSupportDeliveryDate;
const generateRoomData = ({ roomData, isEdit, isTempSave, isDemandSurvey, isCommission, }) => {
    const { title, delivery_region, // ? 수정 | 수요조사 | 커미션 필요 없음
    is_ticket, // ? 수정 | 수요조사 | 커미션 필요 없음
    room_type_cd, // ? 수정 | 수요조사 | 커미션 필요 없음
    start_date, end_date, // ! 커미션은 무조건 '9999-12-31T23:59:59'
    support_delivery_date, // ? 수요조사 | 커미션 필요 없음
    category, fee_free, contents, tag, paytype, snstype, // ? 커미션 필요 없음
    is_refund_account, // ? 수요조사 | 커미션 필요 없음
    second_paid, // ? 수요조사 | 커미션 필요 없음
    second_custom, // ? 수요조사 | 커미션 필요 없음
    publictype, is_marketing_consent, // ? 수요조사 | 커미션 필요 없음
    transfer, // ? 수요조사 | 커미션 필요 없음
    is_order_active, // ! 커미션에만 필요
    is_new_room_opening, // ? 수정 | 임시저장 | 수요조사 | 커미션 필요 없음
     } = roomData;
    const startDateKST = (0, string_utils_1.changeLocalToKSTTime)(start_date);
    const endDateKST = (0, string_utils_1.changeLocalToKSTTime)(end_date);
    const deliveryDateKST = !!support_delivery_date
        ? (0, string_utils_1.changeLocalToKSTTime)(support_delivery_date)
        : '9999-12-31T23:59:59'; // ? 상시판매(isRegularSales)일 때 임시값 보내기, 백에서 알아서 처리(endDate + 1yr + 2months)
    const fondIds = (category === null || category === void 0 ? void 0 : category.id) ? [category.id] : undefined;
    // ? 폼|수요조사|커미션 임시저장|생성|수정에 관계없이 필요한 data
    const roomDataObj = {
        room_status_cd: `ROOM_STATUS_${isTempSave ? '00' : '01'}`,
        title,
        start_date: startDateKST,
        end_date: isCommission ? '9999-12-31T23:59:59' : endDateKST,
        fondIds,
        contents,
        tag,
        paytype,
        publictype,
        fee_free,
    };
    if (!isCommission) {
        Object.assign(roomDataObj, { snstype });
    }
    if (isCommission) {
        Object.assign(roomDataObj, { is_order_active });
    }
    if (!isEdit && !isDemandSurvey && !isCommission) {
        Object.assign(roomDataObj, {
            delivery_region,
            is_ticket,
            room_type_cd,
        });
    }
    if (!isEdit && !isTempSave && !isDemandSurvey && !isCommission) {
        !!is_new_room_opening && Object.assign(roomDataObj, { is_new_room_opening });
    }
    if (!isDemandSurvey && !isCommission) {
        Object.assign(roomDataObj, {
            support_delivery_date: deliveryDateKST,
            is_refund_account,
            second_paid,
            second_custom,
            is_marketing_consent,
            transfer,
        });
    }
    if (!isEdit) {
        // ? 수정일 때 필요 없음 + 임시저장일때만 false
        Object.assign(roomDataObj, { isValid: isTempSave ? false : true });
    }
    return roomDataObj;
};
exports.generateRoomData = generateRoomData;
